import { Button, Input } from '@devrangex/rui'
import styled from '@emotion/styled'
import { FormEventHandler, useState } from 'react'

import { LoginInfo } from '../../api'


export interface LoginFormProps {
  onSubmit: (loginInfo: LoginInfo) => void
  isLoading?: boolean
}

const StyledForm = styled.form`
    input {
        margin-bottom: 16px;
    }

    button {
        margin-top: 14px;
    }
`

export default function LoginForm({onSubmit, isLoading}: LoginFormProps) {
  const [account, setAccount] = useState<string>()
  const [password, setPassword] = useState<string>()

  const handleSubmit: FormEventHandler<HTMLFormElement> = (e) => {
    e.preventDefault()

    onSubmit({
      userAccount: account,
      userPW: password,
    })
  }

  return (
    <StyledForm onSubmit={handleSubmit} role="form">
      <Input
        kiosk
        defaultValue={account}
        placeholder="아이디"
        onChange={(e) => setAccount(e.currentTarget.value)}
      />
      <Input
        kiosk
        type="password"
        defaultValue={password}
        placeholder="비밀번호"
        onChange={(e) => setPassword(e.currentTarget.value)}
      />
      <Button
        role="button"
        type="submit"
        disabled={!(account && password) ? true : false}
        isLoading={isLoading}
      >
        로그인
      </Button>
    </StyledForm>
  )
}
